import { render, staticRenderFns } from "./thirdCheck.vue?vue&type=template&id=b52fda92&scoped=true&"
import script from "./thirdCheck.vue?vue&type=script&lang=js&"
export * from "./thirdCheck.vue?vue&type=script&lang=js&"
import style0 from "./thirdCheck.vue?vue&type=style&index=0&id=b52fda92&scoped=true&lang=css&"
import style1 from "./thirdCheck.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52fda92",
  null
  
)

export default component.exports